
export const BASE_URL = 'https://api-user.mayizhuxue.com'
export const REDIRECT_URL = 'https://h5.mayizhuxue.com'



// export const APPID = 'wx252ffe8a4e04153c'
export const APPID = 'wx7153d710284ee5bb'